import dayjs from "dayjs";
import advancedFormat from 'dayjs/plugin/advancedFormat';
import duration from 'dayjs/plugin/duration';

// Extend Day.js with the duration and advancedFormat plugins
dayjs.extend(duration);
dayjs.extend(advancedFormat);

export const convertMillisecondsToHHMMSS = (milliseconds: number) => {
  const timeDuration = dayjs.duration(milliseconds);
  const hours = String(timeDuration.hours()).padStart(2, '0');
  const minutes = String(timeDuration.minutes()).padStart(2, '0');
  const seconds = String(timeDuration.seconds()).padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
};

export const calculateTimeDifference = (startTime: string, endTime: string) => {
  const start = dayjs(startTime);
  const end = dayjs(endTime);
  const diff = dayjs.duration(end.diff(start));

  const formattedDiff = [
    String(diff.hours()).padStart(2, "0") || "00",
    String(diff.minutes()).padStart(2, "0") || "00",
    String(diff.seconds()).padStart(2, "0") || "00",
  ].join(":");

  return formattedDiff;
};

export const getCurrentPage = (offset: number, limit: number): number => {
  return Math.floor(offset / limit) + 1;
}
